/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2591
 */

var r = require(/* 1451 */"./1451")
var i = require(/* 1450 */"./1450/index")
var o = require(/* 1435 */"../../../../../797/101/2466/1167/1435/index")
var a = require(/* 451 */"../../../../../797/101/2466/2467/451")
module.exports = function (e, t) {
  return (a(e) ? r : i)(e, o(t))
}
